import _ from 'lodash';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const initUserInfo = {
  userInfo: {},
  userInfoState: '',
  registerSelect: 0,
  registerInfo: {},
  userInfoHistory: [],
  hasOTP: false,
};

const userInfo = _.cloneDeep(initUserInfo);

const defaultState = {
  initUserInfo,
  userInfo,
};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
